import fetch from 'isomorphic-fetch'
import * as utils from '../utils.js'

export const do_fetch = function (url, init, f) {
  var _init = Object.assign({}, {credentials: 'same-origin'}, init)

  var csrftoken = utils.docCookies.getItem('csrftoken');
  if (!utils.csrfSafeMethod(init.method) && url[0] == '/') {
    if (!_init.headers) {
      _init.headers = {}
    }
    _init.headers['X-CSRFToken'] = csrftoken
  }

  return fetch(url, _init)
    .then(function(ret) {
       if (ret.status >= 400) {
           throw new Error("Bad response from server");
       }
       return ret.json();
    })
}

export const do_post = function(url, data, init) {
    if (!init) {
      init = {}
    }

    init.method = 'POST'
    if (data) {
      const form = new FormData()
      for ([k, v] of utils.iterelems(data)) {
        form.append(f, v)
      }
      init.body = form
    }

    return do_fetch(url, init)
}

export const load_shops = function () {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/shops?areaid=${encodeURIComponent(store.filter.areaid)}`
      + `&categoryid=${encodeURIComponent(store.filter.categoryid)}`
      + `&styleid=${encodeURIComponent(store.filter.styleid)}`

    return do_fetch(url, {}).then(ret =>
      dispatch({ type: 'SET_SHOPS', shops:ret})
    )
  }
}

export const load_shop = function(shop_id) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/shops/${shop_id}`

    return do_fetch(url, {}).then(ret => {
      return dispatch({ type: 'SET_SHOPS', shops:[ret]})
    })
  }
}



function replace_obj(arr, obj, values) {
  const ret = Array.from(utils.map(arr, v=>{
    if (v.id == obj.id) {
      return Object.assign({}, v, values)
    }
    else {
      return v
    }
  }))
  return ret
}

export const set_shop_fav = function (shop, f) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/shops/${shop.id}/set_fav`
    const form = new FormData()
    form.append("fav", f?'on':'off')

    const init = {
      method: 'POST',
      body: form
    }

    return do_fetch(url, init).then(ret => {
      const shops = replace_obj(store.shops, shop, {fav: f})
      dispatch({ type: 'SET_SHOPS', shops})
    })
  }
}

export const set_shop_memo = function (shop, memo) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/shops/${shop.id}/set_memo`
    const form = new FormData()
    form.append("memo", memo)

    const init = {
      method: 'POST',
      body: form
    }

    return do_fetch(url, init).then(memo => {
      const f = memo.length !== 0
      const shops = replace_obj(store.shops, shop, {memo: f})
      dispatch({ type: 'SET_SHOPS', shops:shops})
    })
  }
}

export const get_shop_memo = function (shop) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/shops/${shop.id}/get_memo`

    const init = {
      method: 'POST',
    }

    return do_fetch(url, init).then(ret => {
      const shops = replace_obj(store.shops, shop, {memotext: ret})
      dispatch({ type: 'SET_SHOPS', shops:shops})
    })
  }
}

function conv_date(girls) {
  for (let g of utils.itervalues(girls)) {
    const schedules = []
    if (g.schedules) {
      for (let s of g.schedules) {
        schedules.push([
          new Date(s[0][0], s[0][1]-1, s[0][2], s[0][3], s[0][4]),
          new Date(s[1][0], s[1][1]-1, s[1][2], s[1][3], s[1][4])
        ])
      }
    }
    g.schedules = schedules
  }
}

export const begin_load_girls = function (shop) {
  return (dispatch, getState) => {
    dispatch({type: 'SET_GIRL_LOADING', shop:shop})
  }
}

export const load_girls = function (shop) {
  return (dispatch, getState) => {
    const url = `/api/shop/girls/${shop.id}`
    return do_fetch(url, {}).then((ret)=> {
      conv_date(ret)
      dispatch({ type: 'SET_GIRLS', shop:shop, girls:ret})
    })
  }
}

export const load_girls_schedule = function (shop) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/shop/schedule/${shop.id}`

    return do_fetch(url, {}).then((ret)=> {
      conv_date(ret)
      dispatch({ type: 'SET_GIRLS', shop:shop, girls:ret})
    })
  }
}

export const set_girl_fav = function (shop, girl, f) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/girls/${girl.id}/set_fav`
    const form = new FormData()
    form.append("fav", f?'on':'off')

    const init = {
      method: 'POST',
      body: form
    }

    return do_fetch(url, init).then(ret => {
      const girls = replace_obj(store.girls[shop.id], girl, {fav: f})
      dispatch({ type: 'SET_GIRLS', shop, girls})
    })
  }
}

export const set_girl_memo = function (shop, girl, memo) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/girls/${girl.id}/set_memo`
    const form = new FormData()
    form.append("memo", memo)

    const init = {
      method: 'POST',
      body: form
    }

    return do_fetch(url, init).then(memo => {
      const f = memo.length !== 0
      const girls = replace_obj(store.girls[shop.id], girl, {memo: f})
      dispatch({ type: 'SET_GIRLS', shop, girls})
    })
  }
}

export const get_girl_memo = function (shop, girl) {
  return (dispatch, getState) => {
    const store = getState()
    const url = `/api/girls/${girl.id}/get_memo`

    const init = {
      method: 'POST',
    }

    return do_fetch(url, init).then(ret => {
      const girls = replace_obj(store.girls[shop.id], girl, {memotext: ret})
      dispatch({ type: 'SET_GIRLS', girls, shop})
    })
  }
}

export const set_filter = function(filter) {
  return {
    type:'SET_FILTER',
    filter
  }
}



// WEBPACK FOOTER //
// ./actions/index.js